// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__PWsME","right":"styles_right__1RqMV"};